import type { OAuthProvider } from 'src/app/auth/domain/models/oauth-provider'

export interface IOAuthCallbackSuccess {
  status: 'success'
  accessToken: string
  provider: OAuthProvider
}

export interface IOAuthCallbackError {
  status: 'error'
  errorDetail?: string
}

export type IOAuthCallbackResult = IOAuthCallbackSuccess | IOAuthCallbackError

const KNOWN_PROVIDERS: ReadonlySet<string> = new Set(['google', 'microsoft'])

const isOAuthProvider = (value: string | null): value is OAuthProvider =>
  value !== null && KNOWN_PROVIDERS.has(value)

export const parseCallbackParams = (search: string): IOAuthCallbackResult => {
  const params = new URLSearchParams(search)

  const errorParam = params.get('error')
  if (errorParam) {
    const detail = params.get('error_detail')
    return detail
      ? { status: 'error', errorDetail: detail }
      : { status: 'error' }
  }

  const accessToken = params.get('access_token')
  const providerRaw = params.get('provider')
  if (!accessToken || !isOAuthProvider(providerRaw)) {
    return { status: 'error' }
  }

  return { status: 'success', accessToken, provider: providerRaw }
}
